module.exports = __webpack_public_path__ + "img/youhui3.c2fc894c.png";